export const isFileFormat = (format: string, filePath = '') => {
  const extension = format.startsWith('.') ? format : '.' + format
  const fileExtension = filePath
    .slice(filePath.lastIndexOf('.'))
    .replace('.jpeg', '.jpg')

  return fileExtension === extension.replace('.jpeg', '.jpg')
}
